import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'

import EditIcon from '@components/Icon/Edit'
import DeleteIcon from '@components/Icon/Delete'
import Action from '@components/Action'
import ACL from '@components/ACL/ACL'
import { showDialog, isCancellationError } from '@components/Dialog'

class Actions extends Component {
  static propTypes = {
    projectStore: PropTypes.object,
    history: PropTypes.object,
    modalStore: PropTypes.object,
    project: PropTypes.object,
    growlStore: PropTypes.object
  }

  deleteProject = () => {
    this.props.modalStore.show({
      type: 'PROJECT_DELETE_MODAL',
      props: { projectStore: this.props.projectStore }
    })
  }

  render () {
    const { modalStore, project, projectStore } = this.props
    return (
      <div className='actions-wrapper actions-wrapper--absolute'>
        <ul className='actions'>
          <ACL inline roles={['Admin']}>
            <li onClick={this.deleteProject}>
              <Action>
                <DeleteIcon />
                <span>Delete</span>
              </Action>
            </li>
          </ACL>
          <ACL
            inline
            roles={[
              'FeeManagement',
              'Accounting',
              'AdvancedExpertManagement',
              'ProjectManagement',
              'AdvancedReporting',
              'Admin'
            ]}
          >
            <li
              data-cy='edit-project-btn'
              onClick={e => {
                return modalStore.show({
                  type: 'PROJECT_FORM',
                  props: {
                    title: 'Set EPL status to Canceled',
                    cancelText: 'Cancel',
                    okText: 'Create',
                    project: project,
                    projectStore: projectStore
                  }
                })
              }}
            >
              <Action>
                <EditIcon />
                <span>Edit</span>
              </Action>
            </li>
          </ACL>
        </ul>
      </div>
    )
  }
}

export default withRouter(
  inject('modalStore', 'projectStore', 'growlStore')(observer(Actions))
)
